import Login from "pages/login/Login.js";
import Signup from "pages/login/Signup.js";
import Details from "pages/login/Details.js";
import ForgotPass from "pages/login/ForgotPass.js";
import ForgotPass2 from "pages/login/ForgotPass2.js";
import Logout from "pages/login/Logout.js";

var routes = [
    {
        path: "/login",
        name: "Login",
        icon: "ni ni-key-25 text-info",
        component: Login,
        layout: "/auth",
    },
    {
        path: "/signup",
        name: "Signup",
        icon: "ni ni-circle-08 text-pink",
        component: Signup,
        layout: "/auth",
    },
    {
        path: "/details",
        name: "Details",
        icon: "ni ni-circle-08 text-pink",
        component: Details,
        layout: "/auth",
    },
    {
        path: "/forgot-password",
        name: "ForgotPass",
        icon: "ni ni-circle-08 text-pink",
        component: ForgotPass,
        layout: "/auth",
    },
    {
        path: "/confirm-password",
        name: "ForgotPass2",
        icon: "ni ni-circle-08 text-pink",
        component: ForgotPass2,
        layout: "/auth",
    },
    {
        path: "/logout",
        name: "Logout",
        icon: "ni ni-circle-08 text-pink",
        component: Logout,
        layout: "/auth",
    },
];
export default routes;
